/**
 * Helper: Product
 * -----------------------------------------------------------------------------
 * Helper functions specific to products.
 * - Add in alphabetical order.
 *
 */

/**
 * Get array of disabled color codes from a given set of tags.
 * @param {Array} tags - Product tag array.
 * @returns {Array}
 */
export function getDisabledColorCodes(tags) {
  if (!tags) {
    return []
  }

  return tags
    .filter((tag) => tag.includes('disabled-variant:'))
    .map((tag) => tag.split(':')[1])
}

/**
 * Return if a given 3 letter colour code is present in a specific string.
 * @param {String} colorCode - 3 letter colour code.
 * @param {String} targetString - Target string (e.g. image src)
 * @returns {Boolean}
 */
export function isColorCodeInStr(colorCode, targetString) {
  if (!colorCode || !targetString) {
    return false
  }

  return targetString.includes(colorCode) || targetString.includes(colorCode.toLowerCase())
}
